import { call, takeLatest, put } from 'redux-saga/effects';
import { CloudActions } from '@portal/portal-core';

import { sendAction } from '../api';
import type { SuperClientAction, SuperClientConfig, WrapResult } from '../api';
import { setSelectedUserCCs } from '../actions';

// The dispatched action always carries a concrete `type`; requiring it here lets
// redux-saga's `takeLatest` currying overload match (its last-param check needs a
// required `type` to satisfy the `Action` constraint).
interface CostCentersByUserAction extends SuperClientAction {
  type: string;
}

// Fetch license data on load or after change
export function* fetchCostCentersByUser(
  config: SuperClientConfig,
  action: CostCentersByUserAction,
): Generator<unknown, void, unknown> {
  try {
    const res = (yield call(sendAction, config, action)) as WrapResult;
    yield put(setSelectedUserCCs(res.data as unknown[]));
  } catch (error) {
    console.error('fetchAllUsers failed -- ', error);
  }
}

/* istanbul ignore next reason: no saga watch tests */
export function* watchFetchCostCentersByUser(
  config: SuperClientConfig,
): Generator<unknown, void, unknown> {
  yield takeLatest(CloudActions.ADMIN_GET_COST_CENTERS_BY_USER, fetchCostCentersByUser, config);
}
